import { useState, useEffect } from "react";

function useMobileLandscape() {
  const [isMobileLandscape, setIsMobileLandscape] = useState(false);

  useEffect(() => {
    const checkMobileLandscape = () => {
      const isMobile =
        /Mobi|Android/i.test(navigator.userAgent) ||
        (navigator.maxTouchPoints && navigator.maxTouchPoints > 1);
      const isLandscape = window.innerWidth > window.innerHeight;

      setIsMobileLandscape(isMobile && isLandscape);
    };

    // Initial check
    checkMobileLandscape();

    // Add event listeners for screen orientation or resize
    window.addEventListener("resize", checkMobileLandscape);
    window.addEventListener("orientationchange", checkMobileLandscape);

    return () => {
      // Clean up listeners
      window.removeEventListener("resize", checkMobileLandscape);
      window.removeEventListener("orientationchange", checkMobileLandscape);
    };
  }, []);

  return isMobileLandscape;
}

export default useMobileLandscape;